const KNOWN_CART_URLS = [
    '/onestepcheckout',
    '/cart',
    '/checkout/cart',
    '/panier',
    '/kassa',
    '/carrinho'
];
export default function isCartPage(platform) {
    if (platform === "WooCommerce" && typeof wc_cart_params !== "undefined") {
        return true;
    }
    if (platform === "BigCommerce" && window.location.href.includes('cart.php')) {
        return true;
    }
    const path = window.location.pathname.replace(/\/$/, "");
    return Boolean(KNOWN_CART_URLS.find(item => path.includes(item)));
}
//# sourceMappingURL=isCartPage.js.map